module.exports = __webpack_public_path__ + "img/home.d0f31bc7.svg";